import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import {labels} from '../../../util/utils';

import OutputText from '@ey/canvascoreservices/OutputText';

import Modal from '../../CoreWrappers/Modal';

const SoftwareUpdateModal = () => {
	const appVersionState = useSelector((store) => store.appVersion);

	const props = {
		show: appVersionState.upgrade,
		modalsize: 'x-small',
		labels: {
			modalConfirmBtnLabel: labels.updateNow,
			modalCancelBtnLabel: '',
			modalCloseBtnTitletip: labels.close
		},
		headerText: labels.softwareUpdate,
		onOkClick: () => {
			localStorage.setItem('app.version', appVersionState.version);
			window.location.reload();
		},
		hideCloseButton: true
	};

	return (
		<Modal {...props}>
			<OutputText light>{labels.updateMsg}</OutputText>
		</Modal>
	);
};

SoftwareUpdateModal.propTypes = {};

export default SoftwareUpdateModal;
